import { useTimezone } from '@mews-framework/globalization';
import { useAppClockService } from './appClock';
import { utcToStructuredDate } from './dateTimeUtils';

export const useTodayAsStructuredDate = () => {
    const appClockService = useAppClockService();
    const timezone = useTimezone();
    return utcToStructuredDate(appClockService.getAppNowUtc().value, timezone);
};
